__turbopack_context__.v({
  "body": "FnXTfa_body",
  "caption": "FnXTfa_caption",
  "dayCell": "FnXTfa_dayCell",
  "dayFill": "FnXTfa_dayFill",
  "desktopSpacer": "FnXTfa_desktopSpacer",
  "mobileOnly": "FnXTfa_mobileOnly",
  "month": "FnXTfa_month",
  "monthLabel": "FnXTfa_monthLabel",
  "months": "FnXTfa_months",
  "navButton": "FnXTfa_navButton",
  "root": "FnXTfa_root",
  "row": "FnXTfa_row",
  "secondMonth": "FnXTfa_secondMonth",
  "spacer": "FnXTfa_spacer",
  "weekdayBar": "FnXTfa_weekdayBar",
  "weekdayCell": "FnXTfa_weekdayCell",
  "weeks": "FnXTfa_weeks",
});
